import BaseEntity from "@/core/misc/BaseEntity";
import ContactsService from "@/domains/Contacts/ContactsService";
import Title_ru_RU from "@/core/misc/decorators/Title_ru_RU";
import TYPES from "@/core/services/Changelogs/types";
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";

@Title_ru_RU_Class('Контакт')
class Contact extends BaseEntity {

	static Events = {
		Created: 'contact:created',
		Updated: 'contact:updated',
		Deleted: 'contact:deleted'
	} as const;

	/** Тип контакта, email телефон и т.п */
	@Title_ru_RU('Тип контакта', TYPES.STRING)
	public type: { id: string; name: string | null } | null;

	@Title_ru_RU('Значение', TYPES.STRING)
	public value: string | null;

	/** Доп данные, напр добавочный номер */
	@Title_ru_RU('Дополнительные данные', TYPES.STRING)
	public additionalData: any;

	/** Приоритетный-ли контакт для связи */
	@Title_ru_RU('Приоритетный контакт', TYPES.BOOLEAN)
	public isPreferred: boolean;

	/** комментарий */
	@Title_ru_RU('Комментарий', TYPES.STRING)
	public comment: string | null;

	constructor() {
		super();
		this.type = null;
		this.value = '';
		this.comment = ''; // ← строка, а не []
		this.additionalData = null;
	}

	static get types(): Map<string, { name: string }> {
		return new Map([
			["phone", { name: "Телефон" }],
			["skype", { name: "Skype" }],
      ["email", { name: "Email" }],
		]);
	}

	static fromServer(data: any, result = new Contact()): Contact {
		const contact = super.fromServer(data, result);

		/** TODO: может просто тогда на беке name докидывать? */

		// Если type есть и это объект — обогащаем name
		if (data?.type?.id) {
			contact.type = {
				id: data.type.id,
				name: data.type.name ?? ContactsService.getTypeById(data.type.id)?.name ?? null,
        toString() {return this.name},
			};
		} else {
			contact.type = null;
		}

		return contact;
	}

	getTypeStringRepresentation(): string {
		if (!this.type?.id) {
			return "--";
		}
		return Contact.types.get(this.type.id)?.name ?? "--";
	}
}

export default Contact;
